import type { SimulatorProfileDefinition } from "../contracts/appManifest.js";

export const server2025Profile: SimulatorProfileDefinition = {
  id: "server-2025",
  title: "FirstDesk Server 2025 Lab",
  productLabel: "FirstDesk Server 2025 Lab",
  machineRole: "server",
  theme: "server",
  desktopAppIds: ["server-manager", "explorer", "cmd", "aduc", "dns-manager", "dhcpManager", "gpmc"],
  pinnedAppIds: ["server-manager", "explorer", "cmd", "services", "eventvwr"],
  defaultOpenAppIds: ["server-manager"],
  startMenuSections: [
    {
      title: "Server",
      appIds: ["server-manager", "services", "eventvwr", "taskschd", "remoteDesktop", "controlPrinters", "cmd", "explorer"]
    },
    {
      title: "Directory and infrastructure",
      appIds: ["aduc", "dns-manager", "dhcpManager", "gpmc", "lusrmgr", "sysdm", "ncpa"]
    }
  ]
};
